import {isAxiosError} from 'axios';
import {InferType} from 'yup';

import {axi, getDateFromIsoString} from '@shared/api';
import {validateData} from '@shared/utils';
import {UserExtData} from '../types';
import {userExtDataListV8nSchema, userExtDataV8nSchema} from './backendSchemas';

type UserExtDataOnBackend = InferType<typeof userExtDataV8nSchema>;

const mapUserExtData = (data: UserExtDataOnBackend): UserExtData => ({
  name: data.name,
  value: data.value,
  created: getDateFromIsoString(data.created_at),
});

export const getUserExtData = async (
  userId: string,
): Promise<UserExtData[]> => {
  const response = await axi.get<UserExtDataOnBackend[]>(
    `/admin/users/${userId}/ext-data`,
  );
  validateData(response.data, userExtDataListV8nSchema, 'getUserExtData');
  return response.data.map(item => mapUserExtData(item));
};

export const getUserExtDataByName = async (
  userId: string,
  name: string,
): Promise<UserExtData | null> => {
  try {
    const response = await axi.get<UserExtDataOnBackend>(
      `/admin/users/${userId}/ext-data/${encodeURIComponent(name)}`,
    );
    validateData(response.data, userExtDataV8nSchema, 'getUserExtDataByName');
    return mapUserExtData(response.data);
  } catch (error) {
    if (
      isAxiosError<{detail?: unknown}>(error) &&
      error.response?.status === 404
    ) {
      const details: unknown = error.response.data?.detail;
      if (
        Array.isArray(details) &&
        details.some(
          (item: unknown) =>
            typeof item === 'object' &&
            item !== null &&
            'type' in item &&
            item.type === 'UserExtDataNotFoundException',
        )
      ) {
        return null;
      }
    }
    throw error;
  }
};
